export default __webpack_public_path__ + "13fbb47065f50ac414351d56887251a7.svg";